import { Link, LinkProps } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

interface AuthLinkProps extends Omit<LinkProps, "component"> {
  to: string;
  children: React.ReactNode;
}

const AuthLink: React.FC<AuthLinkProps> = ({ to, children, sx, ...props }) => {
  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      sx={{
        fontWeight: 700,
        fontSize: 16,
        color: "var(--hot)",
        "&:hover": {
          color: "color-mix(in oklab, var(--hot) 85%, #fff)",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

export default AuthLink;
